import pica from 'pica';

/**
 * This function resizes the uploaded image based on the size of the placeholder
 * @param {string} base64 - base64 encoded uploaded image
 * @param {type} string - type of uploaded image
 */
export default (base64: string, type: string) =>
    new Promise<string>((resolve, reject) => {
        try {
            const img = new Image();
            img.onload = () => {
                const { width, height } = img;
                const canvas = document.createElement('canvas');
                const canvasCopy = document.createElement('canvas');
                const copyContext = canvasCopy.getContext('2d');

                canvasCopy.width = width;
                canvasCopy.height = height;

                if (copyContext) {
                    copyContext.drawImage(img, 0, 0);
                }

                // all images will be scaled down to 600
                canvas.width = 600;
                canvas.height = (height / width) * 600;

                pica()
                    .resize(canvasCopy, canvas, {
                        quality: 3,
                        unsharpAmount: 10,
                        unsharpRadius: 0.5,
                        unsharpThreshold: 0,
                        alpha: true,
                    })
                    .then(() => {
                        resolve(canvas.toDataURL(type));
                    })
                    .catch((err) => {
                        throw new Error(err);
                    });
            };

            img.src = base64;
        } catch (err) {
            reject(err);
        }
    });
